import React, { useContext } from "react";
import "./Mail.scss";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useFormik } from "formik";
import * as yup from "yup";
import MyContext from "../../../../Uttis/MyContext";

// ✅ Validation Schema
const validationSchema = yup.object({
  name: yup.string().required("Name is required"),
  email: yup.string().email("Enter a valid email").required("Email is required"),
  phone: yup
    .string()
    .matches(/^[0-9]{10}$/, "Enter a valid 10-digit phone number")
    .required("Phone number is required"),
  message: yup
    .string()
    .required("Message is required")
    .min(5, "Message should be at least 5 characters"),
});

const Mail = () => {
  const { setSnack, setLoading, setMessage, url } = useContext(MyContext);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      message: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        document.body.style.overflow = "hidden";

        const response = await fetch(`${url}/contact`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(values),
        });

        const data = await response.json();

       

        if (data.success){
          setMessage(data.message);
          setSnack(true);
           resetForm();
        } else {
          setMessage(data.message || "Failed to send message.");
          setSnack(true);
        }
      } catch (error) {
        setMessage("Failed to send message. Please try again later.");
        setSnack(true);
      } finally {
        setLoading(false);
        document.body.style.overflow = "auto";
      }
    },
  });

  return (
    <div className="mail-form-container">
      <form onSubmit={formik.handleSubmit} className="mail-form">
        <h2>Send us a Message</h2>

        <div className="form-fields">
          <TextField
            fullWidth
            id="name"
            name="name"
            label="Name"
            variant="standard"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
          />

          <TextField
            fullWidth
            id="email"
            name="email"
            label="Email"
            variant="standard"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />

          <TextField
            fullWidth
            id="phone"
            name="phone"
            label="Phone"
            variant="standard"
            value={formik.values.phone}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.phone && Boolean(formik.errors.phone)}
            helperText={formik.touched.phone && formik.errors.phone}
          />

          <TextField
            fullWidth
            multiline
            rows={4}
            id="message"
            name="message"
            label="Message"
            variant="standard"
            value={formik.values.message}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.message && Boolean(formik.errors.message)}
            helperText={formik.touched.message && formik.errors.message}
          />
        </div>

        <Button type="submit" variant="contained" className="submit-btn">
          Send Message
        </Button>
      </form>
    </div>
  );
};

export default Mail;
